export enum NotificationDomain {
	USER_MODULE_SUGGESTIONS = 'USER_MODULE_SUGGESTIONS',
	USER_TASK_EXPORT_TASK = 'USER_TASK_EXPORT_TASK',
	USER_MODULE_METADATA = 'USER_MODULE_METADATA',
	EXTERNAL_EVENT_TASK = 'EXTERNAL_EVENT_TASK',
	USER_USAGE_STATS = 'USER_USAGE_STATS',
	USER_MODULE_PUSH = 'USER_MODULE_PUSH',
	USER_STATISTICS = 'USER_STATISTICS',
	NOTIFICATION = 'NOTIFICATION',
	USER_PLAN = 'USER_PLAN',
	MESSAGE = 'MESSAGE',
}
